import type { OverlayBadgeDesignTokens } from '@primeuix/themes/types/overlaybadge';

 export default {
    root: {
        outline: {
            color: "{content.background}",
            width: "2px"
        }
    }
} satisfies OverlayBadgeDesignTokens;